import { toast } from "react-toastify";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";
import { API_ENTIDADES } from "../views/MainLayout/components/shared/services/clientes";

const initialClientes = []

export const clientesReducer = (state = initialClientes, action) => {
    switch(action.type){
        case "clientes/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchClientes = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await API_ENTIDADES.getEntidades(page, search)
        const data = await response.data;
        dispatch({ type: 'clientes/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}